import {BasicCriteria} from '../../../allkey/framework/parameters/BasicCriteria';

export class ProcessCriteria extends BasicCriteria {
onlyScheduled: boolean | null;
visionCode: string;
}

